import { render, staticRenderFns } from "./DeliveryMediaRow.vue?vue&type=template&id=fd88f6e4&scoped=true"
import script from "./DeliveryMediaRow.vue?vue&type=script&lang=ts"
export * from "./DeliveryMediaRow.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryMediaRow.vue?vue&type=style&index=0&id=fd88f6e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd88f6e4",
  null
  
)

export default component.exports